/** Outils d'affichage des annonces : adresse lisible et fraîcheur de publication. */

/** Adresse lisible d'une annonce (/annonces/nina-escorte-cocody-a1b2c3). */
export const lienAnnonce = (annonce) =>
  `/annonces/${annonce?.slug || annonce?.id || ""}`;

/** Publiée il y a moins de 48 h : on la met en avant d'un badge « Nouveau ». */
export const estNouvelleAnnonce = (dateDebut) => {
  if (!dateDebut) return false;
  const publiee = new Date(dateDebut).getTime();
  if (Number.isNaN(publiee)) return false;
  return Date.now() - publiee < 48 * 60 * 60 * 1000;
};

/** Badge « Nouveau » commun à toutes les vitrines. */
export const BadgeNouveau = ({ testid = null, className = "" }) => (
  <span
    data-testid={testid || "badge-nouveau"}
    className={`inline-flex items-center gap-1 rounded-full bg-[#E05638] px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-white shadow-sm ${className}`}
  >
    <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-white" /> Nouveau
  </span>
);
